import { UserStatus } from '@/models/users.model';
import { IFullAddress } from '@/models/addresses.model';

export enum UserFiltersFields {
  EMAIL = 'email',
  ADDRESS = 'address',
  NAME = 'full_name',
  ROLE = 'role',
  STATUS = 'status',
  CURSOR = 'cursor',
  PHONE_NUMBER = 'phone_number',
  TRIPLETEX_CUSTOMER_NUMBER = 'tripletex_customer_number',
}

export enum UserFormFieldsNames {
  EMAIL = 'email',
  ADDRESS = 'address',
  INVOICE_ADDRESS = 'invoice_address',
  NAME = 'full_name',
  ROLE = 'role',
  STATUS = 'status',
  PHONE_NUMBER = 'phone_number',
}

export type TUserFormValues = {
  [UserFormFieldsNames.EMAIL]?: string;
  [UserFormFieldsNames.NAME]: string;
  [UserFormFieldsNames.STATUS]: UserStatus;
  [UserFormFieldsNames.PHONE_NUMBER]: string;
  [UserFormFieldsNames.INVOICE_ADDRESS]: IFullAddress;
  [UserFormFieldsNames.ADDRESS]: IFullAddress;
};

export type TUserFiltersValues = {
  [UserFiltersFields.STATUS]?: UserStatus;
  [UserFiltersFields.EMAIL]?: string;
  [UserFiltersFields.ADDRESS]?: string;
  [UserFiltersFields.NAME]?: string;
  [UserFiltersFields.PHONE_NUMBER]?: string;
  [UserFiltersFields.CURSOR]?: string;
  [UserFiltersFields.TRIPLETEX_CUSTOMER_NUMBER]?: string;
  limit?: number;
};
